const exceptions = {
    availability: "Availability Exceptions",
    stores: "Multiple assignments per store",
    travel: "Travel Charges"
};

export default exceptions;
